<template>
  <div
    class="pay-way"
  >
    <div class="way-title">
      <img
        width="24"
        src="@/assets/images/icon/cost.png"
        alt=""
      >
      <span>{{$t('management_fee')}}+{{$t('Performance_fee')}}</span>
      <span
        v-if="isFree"
        class="free-text">{{$t('free')}}</span>
    </div>
    <div
      v-if="!isFree"
      class="subtitle fs12">
      {{$t('management_fee')}}{{managementFee}}，{{$t('mamSubCopyMoneyTips')}}
    </div>
    <div
      v-if="!isFree"
      class="pay-details mam-pay-details-money">
      <el-row class="odd-box line-box">
        <el-col :span="12">
          {{$t('rate_of_return')}}
        </el-col>
        <el-col :span="12">
          {{$t('Share_ratio')}}
        </el-col>
      </el-row>
      <!--                                    ≥10%-->
      <el-row
        class="line-box"
        :class="{'odd-box': index % 2 !== 0}"
        v-for="(item,index) in profots"
        :key="index"
      >
        <el-col :span="12">
          {{getProfitValue(item)}}
        </el-col>
        <el-col :span="12">
          {{item.shareValue}}
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "payWay",
  props: {
    profots: {
      type: Array,
    },
    managementFee:{

    }
  },
  computed: {
    isFree(){
      return (!this.managementFee || (this.managementFee + '').includes('0')) && !this.profots.length
    }
  },
  methods: {
    getProfitValue(item){
      return `≥${item.profitValue * 100}%`;
    },
  },
}
</script>

<style lang="scss" scoped>
.pay-way {
  border-radius: 5px;
  border: 1px solid #E6E6E6;
  padding: 15px 20px;

  .line-box {
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    &.odd-box {
      background-color: #F9FAFB;
    }
  }
  .free-text {
    position: absolute;
    right: 20px;
  }
}
</style>
